export function stopRecord(stream) {
  stream?.getTracks().forEach((track) => {
    if (track.readyState === 'live') {
      track.stop();
    }
  });
}